import styled from 'styled-components'

const HeaderMainMenu = styled.div`
  width: 100%;
  ${({ style }) => style};
`

export default HeaderMainMenu
